module.exports = __webpack_public_path__ + "static/media/Pinehurst-Acres-Master-Deed.7f3f662b.pdf";